import { SlabPriceTier } from '../types/product.types';
import { getDiscountDetailFromSlabTiers } from './product.util';

export function getSlabPriceValue(
  layout: string,
  slabPriceTiers: SlabPriceTier[] = [],
  productCount = 0,
  productDisplayPrice = 0,
) {
  const isPDP = ['PDP', 'PDP_POPUP'].includes(layout);
  const isSlabPrice = (slabPriceTiers?.length ?? 0) > 0;
  const isPLP_V2 = layout === 'PLP_V2';
  const isSearch = layout === 'SEARCH';
  const dynamicDiscount = getDiscountDetailFromSlabTiers(slabPriceTiers, productCount, productDisplayPrice);
  const priceValue = (isPDP || isPLP_V2 || isSearch) && isSlabPrice ? dynamicDiscount.priceValue : productDisplayPrice;
  return { priceValue, dynamicDiscount, isPLP_V2, isPDP, isSearch };
}
